

















import Vue from 'vue'
import Alert from '@/components/Alert.vue'
import PosterTable from '@/components/PosterTable.vue'
import Worker from '@/components/Worker.vue'
import BackButton from '@/components/BackButton.vue'
import { mapGetters, mapState } from 'vuex'

export default Vue.extend({
  components: {
    Alert,
    PosterTable,
    Worker,
    BackButton,
  },
})
